import { UtilityService } from '@eforall/common';
import { FilterOperator, GridColumn, buildColumn } from '@eforall/dashboard';
import { LanguageId, VolunteerSignupSpecialist } from '@interfaces';
import { AppService } from '../../../../../../services';


export function getColumns(util: UtilityService, app: AppService) {
	const columns: GridColumn<VolunteerSignupSpecialist, unknown>[] = [
		buildColumn(util, 'Id', row => row.assignedToStaffId, { header: 'assignedToStaffId', hidden: true }),
		buildColumn(util, 'FullName', row => app.getStaffNameById(row.assignedToStaffId), { header: 'Assigned Staff', width: 120 }),
		buildColumn(util, 'Id', row => row.lastContactStaffId, { header: 'lastContactStaffId', hidden: true }),
		buildColumn(util, 'FullName', row => app.getStaffNameById(row.lastContactStaffId), { header: 'Last Contacted By', width: 120 }),
		buildColumn(util, 'Date', row => util.date.fromUTC(row.lastContactUTC), { header: 'Last Contact Date', width: 80 }),
		buildColumn(util, 'Id', row => row.volunteerSignupSpecialistId),
		buildColumn(util, 'Id', row => row.volunteerSignupSpecialistTopicId),
		buildColumn(util, 'FullName', row => row.person.fullName, { header: 'Specialist', group: 'asc' }),
		buildColumn(util, 'Text', row => row.topicName, { header: 'Topic Name' }),
		buildColumn(util, 'Id', row => row.topicId, { header: 'TopicId' }),
		buildColumn(util, 'Text', row => row.languageId === LanguageId.English ? 'English' : 'Spanish', { header: 'Language' }),
		buildColumn(util, 'Text', row => app.getTrimesterNameById(row.trimesterId), { header: 'Trimester' }),
		buildColumn(util, 'Text', row => row.volunteerSignupSpecialistStatus, {
			header: 'Status',
			filter: { operator: FilterOperator.Contains, value: 'Pending' }
		}),
		buildColumn(util, 'DateTime', row => util.date.fromUTC(row.availableClassStartTimeUTC), { header: 'Available Start' }),
		buildColumn(util, 'DateTime', row => util.date.fromUTC(row.availableClassEndTimeUTC), { header: 'Available End' }),
	];

	return columns;

}
